import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './SALEPROFIT_Token_Offering.css';

const SALEPROFIT_Token_Offering = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"SALEPROFIT_TOKEN_OFFERING",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	SALEPROFIT_TOKEN_OFFERING:-1
  });


  const [SALEPROFIT_TOKEN_OFFERING, setSALEPROFIT_TOKEN_OFFERING] = React.useState(null);
  const [SALEPROFIT_TOKEN_OFFERING_D, setSALEPROFIT_TOKEN_OFFERING_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Sale Profit Token Offering');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/SALEPROFIT_Token_Offering',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewSALEPROFIT_TOKEN_OFFERING(clientInfo,"OpenNew");

		navigate('/SALEPROFIT_Token_Offering',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Token_Offering_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutSALEPROFIT_TOKEN_OFFERING(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostSALEPROFIT_TOKEN_OFFERING(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewSALEPROFIT_TOKEN_OFFERING(clientInfo,"OpenNew");
		}
		navigate('/SALEPROFIT_Token_Offering',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Token_Offering_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Token_Offering_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Token_Offering_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
		if(Temp_Data2.status!="New"){
			handleDeleteSALEPROFIT_TOKEN_OFFERING(Temp_Data2);
			navigate('/SALEPROFIT_Token_Offering#New',{replace:true});
		} 
		else 
			navigate('/SALEPROFIT_Token_Offering',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Token_Offering',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Token_Offering',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Token_Offering',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Token_Offering',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!SALEPROFIT_TOKEN_OFFERING) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_${i}_SECTION`;
	  const headerId = `#SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [SALEPROFIT_TOKEN_OFFERING]) ;


  
  
  var Ids = [];
  for(var Ele in SALEPROFIT_TOKEN_OFFERING){
	  for(var Sec in SALEPROFIT_TOKEN_OFFERING[Ele]){
		if(Sec == "id")
			Ids.push(SALEPROFIT_TOKEN_OFFERING[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(SALEPROFIT_TOKEN_OFFERING[Ele]["status"]);
		else if(Array.isArray(SALEPROFIT_TOKEN_OFFERING[Ele][Sec]))
			  for(var Row in SALEPROFIT_TOKEN_OFFERING[Ele][Sec])  // Convert to SALEPROFIT_TOKEN_OFFERING[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in SALEPROFIT_TOKEN_OFFERING[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["SALEPROFIT_TOKEN_OFFERING"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewSALEPROFIT_TOKEN_OFFERING(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_TOKEN_OFFERING`).then((response1) => {
		if(!SALEPROFIT_TOKEN_OFFERING) 
			setSALEPROFIT_TOKEN_OFFERING(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_TOKEN_OFFERING_D`).then((response2) => {
			setSALEPROFIT_TOKEN_OFFERING_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddSALEPROFIT_TOKEN_OFFERING_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewSALEPROFIT_TOKEN_OFFERING = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_TOKEN_OFFERING/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setSALEPROFIT_TOKEN_OFFERING(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataSALEPROFIT_TOKEN_OFFERING = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_TOKEN_OFFERING/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutSALEPROFIT_TOKEN_OFFERING = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_TOKEN_OFFERING/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostSALEPROFIT_TOKEN_OFFERING = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_TOKEN_OFFERING', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteSALEPROFIT_TOKEN_OFFERING = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_TOKEN_OFFERING', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["1"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_0"]=value;
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
	Form_Data_onChange("1","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_0",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["1"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_1"]=value;
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
	Form_Data_onChange("1","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_1",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["1"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_2"]=value;
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
	Form_Data_onChange("1","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_2",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["1"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_3"]=value;
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
	Form_Data_onChange("1","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_3",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
 }; 
  

const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["1"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_4"]=value;
	Form_Data_onChange("1","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_4",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
  }; 
  

    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["1"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_5"]=value;
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
	Form_Data_onChange("1","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_5",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
 }; 
  

const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_6_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_6"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["1"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_6"]=value;
	Form_Data_onChange("1","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_6",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
  }; 
  


const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["2"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_0"]=value;
	Form_Data_onChange("2","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_0",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
  }; 
  

    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["2"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_1"]=value;
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
	Form_Data_onChange("2","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_1",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["2"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_2"]=value;
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
	Form_Data_onChange("2","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_2",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["2"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_3"]=value;
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
	Form_Data_onChange("2","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_3",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["3"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_0"]=value;
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
	Form_Data_onChange("3","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_0",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["3"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_1"]=value;
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
	Form_Data_onChange("3","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_1",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["3"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_2"]=value;
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
	Form_Data_onChange("3","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_2",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["4"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_0"]=value;
	Form_Data_onChange("4","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_0",value,Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
  }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["4"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_1"]=value;
	Form_Data_onChange("4","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_1",value,Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
  }; 
  

const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["4"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_2"]=value;
	Form_Data_onChange("4","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_2",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
  }; 
  

  
      
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["7"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_0"]=value ? true : false; // optionally just use boolean
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
	Form_Data_onChange("7","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_0",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
 }; 
  



const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["7"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_1"]=value;
	Form_Data_onChange("7","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_1",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
  }; 
  


const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["7"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_2"]=value;
	Form_Data_onChange("7","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_2",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
  }; 
  

    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["7"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_3"]=value;
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
	Form_Data_onChange("7","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_3",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["7"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_4"]=value;
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
	Form_Data_onChange("7","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_4",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
 }; 
  
  
      
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_5_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["7"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_5"]=value ? true : false; // optionally just use boolean
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
	Form_Data_onChange("7","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_5",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
 }; 
  



const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_6_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_6"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["7"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_6"]=value;
	Form_Data_onChange("7","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_6",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
  }; 
  


const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_7_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_7"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["7"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_7"]=value;
	Form_Data_onChange("7","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_7",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
  }; 
  


const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_8_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_8"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["7"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_8"]=value;
	Form_Data_onChange("7","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_8",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
  }; 
  


const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_9_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_9"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["7"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_9"]=value;
	Form_Data_onChange("7","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_9",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
  }; 
  


const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["9"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_0"]=value;
	Form_Data_onChange("9","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_0",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
  }; 
  

    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["9"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_1"]=value;
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
	Form_Data_onChange("9","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_1",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["9"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_2"]=value;
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
	Form_Data_onChange("9","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_2",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["9"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_3"]=value;
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
	Form_Data_onChange("9","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_3",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
	Temp_Data["9"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_4"]=value;
	//handleAddSALEPROFIT_TOKEN_OFFERING(Temp_Data,App_Data['SALEPROFIT_TOKEN_OFFERING']);
	Form_Data_onChange("9","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_4",value,Temp_Data);
 	//handleLastDataSALEPROFIT_TOKEN_OFFERING(Temp_Data);
    setSALEPROFIT_TOKEN_OFFERING(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!SALEPROFIT_TOKEN_OFFERING) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedSALEPROFIT_TOKEN_OFFERING =JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
  updatedSALEPROFIT_TOKEN_OFFERING[Sec] = [...updatedSALEPROFIT_TOKEN_OFFERING[Sec], newRow];
  setSALEPROFIT_TOKEN_OFFERING(updatedSALEPROFIT_TOKEN_OFFERING);
};

const handleDeleteRow = (sec,index) => {
  const updatedSALEPROFIT_TOKEN_OFFERING = JSON.parse(JSON.stringify(SALEPROFIT_TOKEN_OFFERING));
  updatedSALEPROFIT_TOKEN_OFFERING[sec].splice(index, 1);
  setSALEPROFIT_TOKEN_OFFERING(updatedSALEPROFIT_TOKEN_OFFERING);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Sale Profit Token Offering`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Sale Profit Token Offering ID`)} <span className="toggle-icon">^</span></h2>
            <div id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`SALEPROFIT Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_0" type="text" className="form-control" placeholder="SALEPROFIT Offering ID" value={SALEPROFIT_TOKEN_OFFERING["1"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_0`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter SALEPROFIT Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_1" type="text" className="form-control" placeholder="Offering ID" value={SALEPROFIT_TOKEN_OFFERING["1"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_1`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_2" type="text" className="form-control" placeholder="Asset ID" value={SALEPROFIT_TOKEN_OFFERING["1"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_2`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`SPV ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_3" type="text" className="form-control" placeholder="SPV ID" value={SALEPROFIT_TOKEN_OFFERING["1"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_3`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter SPV ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Token Type Code`)}
					 </div>
                     <div className="card-body" >
                        <select id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_4"  value={SALEPROFIT_TOKEN_OFFERING["1"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_4`]} onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_4_Change} className="form-control" name="Token Type Code"  >
						  <option value="RENT_INCOME_TOKEN">RENT_INCOME_TOKEN</option>
						  <option value="REVENUE_SHARE_TOKEN">REVENUE_SHARE_TOKEN</option>
						  <option value="SALE_PROFIT_TOKEN">SALE_PROFIT_TOKEN</option>
						  <option value="EQUITY_APPRECIATION_TOKEN">EQUITY_APPRECIATION_TOKEN</option>
						  <option value="PREFERRED_EQUITY_TOKEN">PREFERRED_EQUITY_TOKEN</option>
						  <option value="COMMON_EQUITY_TOKEN">COMMON_EQUITY_TOKEN</option>
						  <option value="DEBT_NOTE_TOKEN">DEBT_NOTE_TOKEN</option>
						  <option value="HYBRID_TOKEN">HYBRID_TOKEN</option>
						  <option value="PRE_AUCTION_POOL_TOKEN">PRE_AUCTION_POOL_TOKEN</option>
						  <option value="POST_AUCTION_TOKENIZATION">POST_AUCTION_TOKENIZATION</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Token Type Code
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '180ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_5" type="text" className="form-control" placeholder="Offering Name" value={SALEPROFIT_TOKEN_OFFERING["1"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_5`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_5_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '180ch' }}>
						 {t(`Enter Offering Name`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Offering Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_6"  value={SALEPROFIT_TOKEN_OFFERING["1"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_6`]} onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_1_6_Change} className="form-control" name="Offering Type"  >
						  <option value="Rental Property Offering">Rental Property Offering</option>
						  <option value="Revenue Share Offering">Revenue Share Offering</option>
						  <option value="Sale Profit Offering">Sale Profit Offering</option>
						  <option value="Equity Appreciation Offering">Equity Appreciation Offering</option>
						  <option value="Preferred Equity Offering">Preferred Equity Offering</option>
						  <option value="Common Equity Offering">Common Equity Offering</option>
						  <option value="Debt Note Offering">Debt Note Offering</option>
						  <option value="Hybrid Offering">Hybrid Offering</option>
						  <option value="Pre-Auction Pool">Pre-Auction Pool</option>
						  <option value="Post-Auction Tokenization">Post-Auction Tokenization</option>
						  <option value="Pre-Auction Pool Offering">Pre-Auction Pool Offering</option>
						  <option value="Post-Auction Tokenization Offering">Post-Auction Tokenization Offering</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Offering Type
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`SEC Exemption`)} <span className="toggle-icon">^</span></h2>
            <div id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`SEC Exemption`)}
					 </div>
                     <div className="card-body" >
                        <select id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_0"  value={SALEPROFIT_TOKEN_OFFERING["2"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_0`]} onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_0_Change} className="form-control" name="SEC Exemption"  >
						  <option value="Reg D 506(b)">Reg D 506(b)</option>
						  <option value="Reg D 506(c)">Reg D 506(c)</option>
						  <option value="Reg CF">Reg CF</option>
						  <option value="Reg A Tier 1">Reg A Tier 1</option>
						  <option value="Reg A Tier 2">Reg A Tier 2</option>
						  <option value="Section 4(a)(2)">Section 4(a)(2)</option>
						  <option value="Institutional Private Placement">Institutional Private Placement</option>
						  <option value="TBD">TBD</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter SEC Exemption
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Minimum Investment USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_1" type="text" className="form-control" placeholder="Minimum Investment USD" value={SALEPROFIT_TOKEN_OFFERING["2"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_1`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Minimum Investment USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Target Offering Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_2" type="text" className="form-control" placeholder="Target Offering Amount USD" value={SALEPROFIT_TOKEN_OFFERING["2"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_2`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Target Offering Amount USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Maximum Offering Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_3" type="text" className="form-control" placeholder="Maximum Offering Amount USD" value={SALEPROFIT_TOKEN_OFFERING["2"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_3`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_3_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_2_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Maximum Offering Amount USD`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Token Symbol`)} <span className="toggle-icon">^</span></h2>
            <div id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '20ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Token Symbol`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_0" type="text" className="form-control" placeholder="Token Symbol" value={SALEPROFIT_TOKEN_OFFERING["3"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_0`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '20ch' }}>
						 {t(`Enter Token Symbol`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Total Tokens`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_1" type="text" className="form-control" placeholder="Total Tokens" value={SALEPROFIT_TOKEN_OFFERING["3"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_1`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Total Tokens`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Token Price USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_2" type="text" className="form-control" placeholder="Token Price USD" value={SALEPROFIT_TOKEN_OFFERING["3"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_2`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_2_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_3_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Token Price USD`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Offering Start Date`)} <span className="toggle-icon">^</span></h2>
            <div id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_SECTION" className="row">
			                {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Offering Start Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_0" type="date"  value={SALEPROFIT_TOKEN_OFFERING["4"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_0`]} 
							onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_0_Change} style={{ borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_0"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Offering Start Date
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Offering End Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_1" type="date"  value={SALEPROFIT_TOKEN_OFFERING["4"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_1`]} 
							onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_1_Change} style={{ borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_1"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Offering End Date
					  </div>
				  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Offering Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_2"  value={SALEPROFIT_TOKEN_OFFERING["4"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_2`]} onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_4_2_Change} className="form-control" name="Offering Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Readiness Review">Readiness Review</option>
						  <option value="Open">Open</option>
						  <option value="Paused">Paused</option>
						  <option value="Closed">Closed</option>
						  <option value="Funded">Funded</option>
						  <option value="Cancelled">Cancelled</option>
						  <option value="Archived">Archived</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Offering Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Sales Map Listing Enabled`)} <span className="toggle-icon">^</span></h2>
            <div id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_SECTION" className="row">
			                 {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Sales Map Listing Enabled`)} <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_0_Change} 
					  checked={SALEPROFIT_TOKEN_OFFERING?.["7"]?.["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_0"] === "true" || SALEPROFIT_TOKEN_OFFERING?.["7"]?.["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_0"] === true} />
					</label>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sales Map Listing Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_1"  value={SALEPROFIT_TOKEN_OFFERING["7"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_1`]} onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_1_Change} className="form-control" name="Sales Map Listing Status"  >
						  <option value="Not Listed">Not Listed</option>
						  <option value="Pre-Listing Draft">Pre-Listing Draft</option>
						  <option value="Preview Only">Preview Only</option>
						  <option value="Listed - Not Investable">Listed - Not Investable</option>
						  <option value="Listed - Investment Open">Listed - Investment Open</option>
						  <option value="Paused">Paused</option>
						  <option value="Closed">Closed</option>
						  <option value="Archived">Archived</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sales Map Listing Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sales Map First Display Trigger`)}
					 </div>
                     <div className="card-body" >
                        <select id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_2"  value={SALEPROFIT_TOKEN_OFFERING["7"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_2`]} onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_2_Change} className="form-control" name="Sales Map First Display Trigger"  >
						  <option value="Asset Profile Created">Asset Profile Created</option>
						  <option value="Map Minimum Data Ready">Map Minimum Data Ready</option>
						  <option value="Offering Draft Created">Offering Draft Created</option>
						  <option value="Compliance Pre-Review Started">Compliance Pre-Review Started</option>
						  <option value="Offering Submitted">Offering Submitted</option>
						  <option value="Offering Approved">Offering Approved</option>
						  <option value="Manual Publish">Manual Publish</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sales Map First Display Trigger
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '180ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Sales Map Public Title`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_3" type="text" className="form-control" placeholder="Sales Map Public Title" value={SALEPROFIT_TOKEN_OFFERING["7"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_3`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_3_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '180ch' }}>
						 {t(`Enter Sales Map Public Title`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '1000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Sales Map Public Summary`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_4" type="text" className="form-control" placeholder="Sales Map Public Summary" value={SALEPROFIT_TOKEN_OFFERING["7"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_4`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_4_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '1000ch' }}>
						 {t(`Enter Sales Map Public Summary`)}
                     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_5" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Sales Map Minimum Data Ready`)} <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_5" type="checkbox" style={{ marginLeft: '5px' }}  onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_5_Change} 
					  checked={SALEPROFIT_TOKEN_OFFERING?.["7"]?.["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_5"] === "true" || SALEPROFIT_TOKEN_OFFERING?.["7"]?.["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_5"] === true} />
					</label>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sales Map Security Display Level`)}
					 </div>
                     <div className="card-body" >
                        <select id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_6"  value={SALEPROFIT_TOKEN_OFFERING["7"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_6`]} onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_6_Change} className="form-control" name="Sales Map Security Display Level"  >
						  <option value="Minimal Public">Minimal Public</option>
						  <option value="Public After Compliance Precheck">Public After Compliance Precheck</option>
						  <option value="Investor Login Required">Investor Login Required</option>
						  <option value="KYC Required">KYC Required</option>
						  <option value="Accreditation Required">Accreditation Required</option>
						  <option value="Admin Only">Admin Only</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sales Map Security Display Level
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sales Map Risk Display Level`)}
					 </div>
                     <div className="card-body" >
                        <select id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_7"  value={SALEPROFIT_TOKEN_OFFERING["7"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_7`]} onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_7_Change} className="form-control" name="Sales Map Risk Display Level"  >
						  <option value="No Risk Shown">No Risk Shown</option>
						  <option value="Color Only">Color Only</option>
						  <option value="Summary Risk">Summary Risk</option>
						  <option value="Full Risk Score">Full Risk Score</option>
						  <option value="Compliance Approved Risk Only">Compliance Approved Risk Only</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sales Map Risk Display Level
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sales Map Boundary Display Mode`)}
					 </div>
                     <div className="card-body" >
                        <select id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_8"  value={SALEPROFIT_TOKEN_OFFERING["7"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_8`]} onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_8_Change} className="form-control" name="Sales Map Boundary Display Mode"  >
						  <option value="Show Exact Boundary">Show Exact Boundary</option>
						  <option value="Show Approximate Boundary">Show Approximate Boundary</option>
						  <option value="Show Center Pin Only">Show Center Pin Only</option>
						  <option value="Show Bounding Box">Show Bounding Box</option>
						  <option value="Hide Boundary Until Approved">Hide Boundary Until Approved</option>
						  <option value="Hide Full Location">Hide Full Location</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sales Map Boundary Display Mode
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sales Map Call To Action Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_9"  value={SALEPROFIT_TOKEN_OFFERING["7"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_9`]} onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_7_9_Change} className="form-control" name="Sales Map Call To Action Status"  >
						  <option value="View Only">View Only</option>
						  <option value="Join Waitlist">Join Waitlist</option>
						  <option value="Request Access">Request Access</option>
						  <option value="Start KYC">Start KYC</option>
						  <option value="Reserve Interest">Reserve Interest</option>
						  <option value="Invest Now">Invest Now</option>
						  <option value="Closed">Closed</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sales Map Call To Action Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_0"  value={SALEPROFIT_TOKEN_OFFERING["9"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_0`]} onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_1" type="text" className="form-control" placeholder="Created By" value={SALEPROFIT_TOKEN_OFFERING["9"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_1`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_2" type="text" className="form-control" placeholder="Created At" value={SALEPROFIT_TOKEN_OFFERING["9"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_2`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_3" type="text" className="form-control" placeholder="Updated By" value={SALEPROFIT_TOKEN_OFFERING["9"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_3`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_4" type="text" className="form-control" placeholder="Updated At" value={SALEPROFIT_TOKEN_OFFERING["9"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_4`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_TOKEN_OFFERING_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default SALEPROFIT_Token_Offering;  